import { DestroyRef, inject, Injectable } from '@angular/core';

import { SSRService } from './ssr.service';

export class Message {
  constructor(
    public type: string,
    public body?: any,
  ) {}
}

@Injectable({
  providedIn: 'root',
})
export class SendMessageService {
  private readonly _destroyRef = inject(DestroyRef);

  constructor(private _SSRService: SSRService) {}

  send(payload: Message) {
    if (this._SSRService.isBrowserOnly) {
      const parentWindow = window.parent;
      const topWindow = window.top;

      if (parentWindow) {
        parentWindow.postMessage(payload, '*');
        return;
      }
      if (topWindow) {
        topWindow.postMessage(payload, '*');
        return;
      }
    }
  }
}
